import { Pipe, PipeTransform } from '@angular/core';
import { Handling } from '../Model/Handling.Model';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'handlingFilter',
  standalone: false
})
export class HandlingFilterPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(handlingList: Handling[], searchTerm: string, field?: string): Handling[] {
    if (!handlingList || !searchTerm?.trim()) {
      return handlingList;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return handlingList.filter(item => {
      if (field && item[field] != null) {
        const value = this.formatValue(item[field], field);
        return value.includes(lowerSearch);
      }

      const defaultFields = [
        'marketCompanyName',
        'unitCost',
        'UserId',
        'LastUpdateDate',
        'UserName',
        'applicationDate'
      ];

      return defaultFields.some(key => {
        const value = this.formatValue(item[key], key);
        return value.includes(lowerSearch);
      });
    });
  }

  private formatValue(value: any, field: string): string {
    if (value == null) return '';

    if (['LastUpdateDate', 'applicationDate'].includes(field)) {
      const formatted = this.datePipe.transform(value, 'MMMM dd, yyyy');
      return formatted ? formatted.toLowerCase() : '';
    }

    return value.toString().toLowerCase();
  }
}
